import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import React, { useState } from "react";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { Typography, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, } from "../mui";
import Comments from "./Comments";
import { commentRole } from "../../utils/enums";
import { getContent } from "../common/content";
const CHAT = gql `
  query Chat($chatId: ID!) {
    chat(id: $chatId) {
      id
      label
      integration {
        id
      }
      comments {
        id
        label
        role
      }
    }
  }
`;
const ADD_CHAT = gql `
  mutation AddChat($data: chatInput!) {
    addChat(data: $data) {
      id
      label
      comments {
        id
        label
        role
      }
    }
  }
`;
const ADD_ASSISTANT_COMMENT = gql `
  mutation AddAssistantComment($data: commentInput!) {
    addAssistantComment(data: $data) {
      id
      label
      role
    }
  }
`;
const Chat = ({ chatId, integrations }) => {
    const [label, setLabel] = useState("");
    const [comments, setComments] = useState([]);
    const [integrationId, setIntegrationId] = useState(integrations?.[0]?.id || null);
    const [getChat, { loading, error, data }] = useLazyQuery(CHAT, {
        onCompleted: (data) => {
            setComments(data?.chat?.comments || []);
        },
        fetchPolicy: "network-only",
    });
    const [addChat] = useMutation(ADD_CHAT, {
        refetchQueries: ["Chats"],
    });
    const [addAssistantComment] = useMutation(ADD_ASSISTANT_COMMENT, {
        refetchQueries: ["Chat"],
    });
    React.useEffect(() => {
        if (chatId) {
            getChat({
                variables: {
                    chatId,
                },
            });
        }
        else {
            setLabel("");
            setComments([]);
        }
    }, [chatId]);
    const handleSubmit = () => {
        if (!label.trim())
            return;
        setComments([
            ...comments,
            {
                role: commentRole.user,
                label,
            },
        ]);
        setLabel("");
        if (chatId) {
            addAssistantComment({
                variables: {
                    data: {
                        chatId,
                        label,
                        role: commentRole.user,
                    },
                },
            });
        }
        else {
            addChat({
                variables: {
                    data: {
                        label: label.slice(0, 10),
                        integrationId,
                        comment: {
                            label,
                        },
                    },
                },
            });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, { container: true, justifyContent: "space-between", children: [_jsx(Grid, { item: true, xs: 2, children: _jsx(Typography, { variant: "subtitle1", sx: { m: 1, fontWeight: "bold" }, children: chatId ? data?.chat?.label : "" }) }), _jsx(Grid, { item: true, xs: 2, children: _jsxs(FormControl, { fullWidth: true, children: [_jsx(InputLabel, { children: getContent("aiModelLabel") }), _jsx(Select, { name: "integrationId", value: chatId ? data?.chat?.integration?.id : integrationId, onChange: (event) => setIntegrationId(event.target.value), label: getContent("aiModelLabel"), size: "small", disabled: chatId, children: integrations?.map((integration, index) => (_jsx(MenuItem, { value: integration.id, children: integration.name }, index))) })] }) })] }), _jsxs(Grid, { container: true, direction: "column", justifyContent: comments.length === 0 ? "center" : "space-between", alignItems: "center", style: { height: "80vh", padding: "1rem" }, children: [comments.length > 0 && _jsx(Comments, { comments: comments }), _jsx(Grid, { item: true, style: { width: comments.length === 0 ? "60%" : "100%" }, children: _jsxs(Grid, { container: true, spacing: 1, alignItems: "center", justifyContent: "center", children: [_jsx(Grid, { item: true, xs: true, children: _jsx(TextField, { fullWidth: true, multiline: true, rows: 4, placeholder: "Ask Anything...", variant: "outlined", value: label, onChange: (e) => setLabel(e.target.value), onKeyDown: (e) => {
                                            if (e.key === "Enter")
                                                handleSubmit();
                                        } }) }), _jsx(Grid, { item: true, children: _jsx(Button, { variant: "contained", color: "primary", onClick: handleSubmit, children: getContent("submitLabel") }) })] }) })] })] }));
};
export default Chat;
